
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.914 11L13.5 2.586 1.586 14.5l6.5 6.5H20.5v-2h-6.586l8-8zm-8.828 6l-2 2H8.914l-4.5-4.5L7.5 11.414 13.086 17zm1.414-1.414L8.914 10 13.5 5.414 19.086 11 14.5 15.586z"}})])
          )
        }
      }
    